import type {ReactNode} from 'react'

import {Card} from '@pleo-io/telescope'

export {LessonNav} from './lesson-nav'
export {UsefulMaterials} from './useful-materials'

export const OverviewRight = ({children}: {children: ReactNode}) => <Card>{children}</Card>
